/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsSlideshowFeaturedCollections = {
	init: function($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsSlideshowFeaturedCollections = $.extend(this, window.PXUTheme.getSectionData($section));

    // Selectors

    const $slideshowFeaturedCollectionsEl = $section.find('[data-slideshow-featured-collections]').removeClass('is-hidden');

    const $slideshowFeaturedCollections = $slideshowFeaturedCollectionsEl.flickity({
      wrapAround: true,
      adaptiveHeight: false,
      prevNextButtons: this.number_of_slides > 1 ? this.show_arrows : true,
      pageDots: this.number_of_slides > 1 ? this.show_nav_buttons : false,
      draggable: true,
      imagesLoaded: true,
      fade: this.image_transition == 'fade' ? true : false,
      autoPlay: this.image_slideshow_speed * 1000,
      arrowShape: arrowShape,
      cellAlign: 'left'
    });

    // Resize flickity when the slider is settled
    $slideshowFeaturedCollectionsEl.on( 'settle.flickity', function() {
      $slideshowFeaturedCollectionsEl.flickity('resize');
    });
  },
  blockSelect: function($section, blockId) {
    const $slider = $section.find('[data-image-slideshow]');
    const $sliderIndex = $('#shopify-section-' + blockId).data('slide-index');

    $slider.flickity('select', $sliderIndex, true, true);

  },
	unload: function($section) {

	}
}

/******/ })()
;